var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.125 0.625H0V12.875H14V3.25H1.75V2.375H13.125V0.625ZM11.375 8.9375C10.8828 8.9375 10.5 8.55469 10.5 8.0625C10.5 7.59766 10.8828 7.1875 11.375 7.1875C11.8398 7.1875 12.25 7.59766 12.25 8.0625C12.25 8.55469 11.8398 8.9375 11.375 8.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddForecast);
export default __webpack_public_path__ + "static/media/add_forecast.ac4327160e4c73f5f0e6d17b71618517.svg";
export { ForwardRef as ReactComponent };